import { Box, Card, Chip, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'src/components/image';
import Carousel, { CarouselArrows, useCarousel } from 'src/components/carousel';
import { IBookPublic } from 'src/types/DTO/public/IBookPublic';
import { IMAGE_HOST_API } from 'src/config-global';
import Iconify from 'src/components/iconify';
import { useNavigate } from 'react-router';
import { paths } from 'src/routes/paths';
import { Ribbon, RibbonContainer } from "react-ribbons";

interface BookCarouselProps {
    recommendedBook: IBookPublic[];
}

export default function BookCarousel({ recommendedBook }: BookCarouselProps) {
    const navigate = useNavigate();
    const theme = useTheme();
    const AVATAR_SIZE = 40;
    const carousel = useCarousel({
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        centerPadding: '0px',
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: recommendedBook?.length > 4 ? 4 : recommendedBook?.length,
        responsive: [
            {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });

    const redirectTo = (slug: any) => {
        navigate(paths.guest.chi_tiet_sach(slug));
    };

    return (
        <>
            <Typography
                variant="h5"
                color={theme.palette.text.disabled}
                sx={{
                    textAlign: 'start',
                    fontWeight: 'bold',
                }}
            >
                Đề xuất cho bạn
            </Typography>
            <Box sx={{ position: 'relative' }}>
                <CarouselArrows
                    filled
                    onPrev={carousel.onPrev}
                    onNext={carousel.onNext}
                    leftButtonProps={{
                        sx: {
                            p: 0.5,
                            mt: -1.5,
                            left: -8,
                            '& svg': { width: 16, height: 16 },
                        },
                    }}
                    rightButtonProps={{
                        sx: {
                            p: 0.5,
                            mt: -1.5,
                            right: -8,
                            '& svg': { width: 16, height: 16 },
                        },
                    }}
                >
                    <Box
                        component={Carousel}
                        ref={carousel.carouselRef}
                        {...carousel.carouselSettings}
                        sx={{
                            width: 1,
                            mx: 'auto',
                            maxWidth: `calc(100% - ${AVATAR_SIZE}px)`,
                        }}
                    >
                        {recommendedBook?.map((row: IBookPublic) => (
                            <Stack
                                key={row.id}
                                sx={{
                                    width: 1,
                                    position: 'relative',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    mx: 1,
                                    boxShadow: 'none'
                                }}
                                spacing={2}
                                component={Card}
                            >
                                <RibbonContainer>
                                    {/* <Ribbon
                                        side="right"
                                        type="corner"
                                        size="normal"
                                        backgroundColor="#ff6b6b"
                                    >
                                        <Iconify icon="mdi:fire" width={16} height={16} />
                                    </Ribbon> */}

                                    <Stack
                                        onClick={() => redirectTo(row.slug)}
                                        direction="row"
                                        spacing={0.5}
                                        sx={{
                                            cursor: 'pointer',
                                            position: 'relative',
                                            border: `solid 1px ${theme.palette.divider}`,
                                            borderRadius: 0.5,
                                            flexGrow: 1,
                                            margin: 1,
                                            padding: 1,
                                            boxShadow: theme.customShadows.z8,
                                        }}
                                    >

                                        <Image
                                            src={IMAGE_HOST_API + row.photoURL}
                                            ratio="1/1"
                                            sx={{
                                                width: 100,
                                                height: 100,
                                                borderRadius: 0.5,
                                                flexShrink: 0,
                                            }}
                                        />
                                        <Stack direction="column" spacing={0.5}
                                            sx={{
                                                marginLeft: 1,
                                                flexGrow: 1,
                                                alignSelf: 'center',
                                            }}>
                                            < Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                {row.name}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {row.author}
                                            </Typography>
                                            <Stack direction="row" sx={{ overflowX: 'auto' }} spacing={0.5}>
                                                <Chip label={row.categoryName} size="small" variant="outlined" />
                                                <Chip label={row.language} size="small" variant="outlined" />
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </RibbonContainer>
                            </Stack>
                        ))}
                    </Box>
                </CarouselArrows >
            </Box>
        </>
    );
}